import { useTranslation } from 'next-i18next';

import { Text, useSlotRecipe } from '@chakra-ui/react';

import { Select } from '@nocowanie/common-ui/components/molecules/select';
import { IconsLinear } from '@nocowanie/icons/linear';

import { SortingSelectProps } from '@app/components/molecules/sorting-select/sorting-select.props';
import { useSearchSorting } from '@app/hooks/useSearchSorting';

export const SortingSelect = ({ sortings, ...props }: SortingSelectProps): JSX.Element => {
    const { t } = useTranslation('listing', { keyPrefix: 'sorting' });
    const { collection, value, defaultValue, onValueChange } = useSearchSorting({ sortings });

    const recipe = useSlotRecipe({ key: 'sortingSelect' });
    const styles = recipe();

    return (
        <Select
            data-testid={'sorting-select'}
            collection={collection}
            size={'lg'}
            closeOnSelect
            lazyMount
            positioning={{
                offset: {
                    mainAxis: -1,
                },
                sameWidth: true,
                flip: false,
            }}
            customTriggerContent={
                <>
                    <IconsLinear.ArrangeVertical w={5} height={5} color={'secondary.solid'} />
                    <Text as={'span'}>{t('title')}</Text>
                </>
            }
            defaultValue={defaultValue}
            value={value}
            onValueChange={e => onValueChange(e.value)}
            contentProps={{
                'data-testid': 'sorting-select-content',
            }}
            itemProps={{
                'data-testid': 'sorting-select-item',
            }}
            triggerProps={{
                'data-testid': 'sorting-select-trigger',
                'aria-label': t('title'),
            }}
            css={styles.sorting}
            {...props}
        ></Select>
    );
};
